import { createAsyncThunk } from "@reduxjs/toolkit";
import ApiService from "../../utils/apiService";

export const fetchBlogs = createAsyncThunk("blogs/fetchAll", async () => {
    return await ApiService.get("/posts",false);
  });
  
  export const fetchBlogById = createAsyncThunk("blogs/fetchById", async (id) => {
    return await ApiService.getById("/posts", id);
  });
  
  